import React from 'react';
import Reveal from 'react-reveal/Reveal';

const ScrollAnimation = ({ children }) => {
  return (
    <Reveal effect="fadeInUp">
      {children}
    </Reveal>
  );
};

export default ScrollAnimation;


// WEBPACK FOOTER //
// ./src/components/ScrollAnimation.js